import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';

export interface DynatraceAPI {
  sendEvent: (event: Record<string, unknown>) => void;
  identifyUser: (id: string) => void;
}

const shouldInitializeDynatrace = () => {
  const env = getEnv();
  const urlParams = new URLSearchParams(window.location.search);

  return (
    env !== ENVS.PRODUCTION || urlParams.get('dynatraceInitialize') === 'true'
  );
};

export function setDynatraceUser(analyticsId?: string) {
  if (!shouldInitializeDynatrace()) {
    return;
  }

  if (!window.dynatrace) {
    report({
      scope: 'ACCExoSkeleton',
      type: REPORT_TYPES.error,
      value:
        'Tried to authenticate Dynatrace with user before Dynatrace was initialized',
      context: {
        analyticsId,
      },
    });
    return;
  }

  if (!analyticsId) {
    report({
      scope: 'ACCExoSkeleton',
      type: REPORT_TYPES.error,
      value: 'Tried to authenticate Dynatrace with empty analyticsId',
      context: {},
    });
    return;
  }

  window.dynatrace.identifyUser(analyticsId);
}
